import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails } from '@mui/material';
import { CohabitationDetailForm } from 'cohabitation/view-models/detail-cohabitation';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { AccordionTitle } from 'shell/components/shared/accordion-title';
import { AccordionGeneralityForm } from 'shell/view-models/accordion-generality-form';
import { AccordionPersonForm } from 'shell/view-models/accordion-person-form';
import { Fragment, memo, useCallback, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import FormGenerality from './form';

interface AccordionGeneralityProps {
  disabled?: boolean;
  isEditMode?: boolean;
}

const AccordionGeneralityComponent = ({
  disabled,
  isEditMode,
}: AccordionGeneralityProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CohabitationDetailForm>();

  const onFieldGeneralityChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('generality', {
        ...formContext.values.generality,
        [key]: value,
      });
    },
    [formContext.values.generality, formContext.setFieldValue]
  );

  const onFieldsGeneralityChange = useCallback(
    (values) => {
      formContext.setFieldValue('generality', {
        ...formContext.values.generality,
        ...(values || {}),
      });
    },
    [formContext.values.generality, formContext.setFieldValue]
  );

  const onFieldPersonChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('person', {
        ...formContext.values.person,
        [key]: value,
      });
    },
    [formContext.values.person, formContext.setFieldValue]
  );

  const onChangeValues = useCallback(
    (values) => {
      formContext.setValues({
        ...formContext.values,
        ...(values || {}),
      });
    },
    [formContext.values, formContext.setValues]
  );

  const resetForm = useCallback(() => {
    formContext.setValues({
      ...formContext.values,
      person: {},
      generality: {},
    });
  }, [formContext.values, formContext.setValues]);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-generality-content"
          id="panel-generality-header"
          expandIcon={<ExpandMore />}
        >
          <AccordionTitle isEditMode={isEditMode}>Generalità</AccordionTitle>
        </AccordionSummary>
        <AccordionDetails>
          <FormGenerality
            disabled={disabled}
            onChangePerson={onFieldPersonChange}
            onChangeGenerality={onFieldGeneralityChange}
            onChangeGeneralityValues={onFieldsGeneralityChange}
            person={formContext.values.person}
            generality={formContext.values.generality}
            isEditMode={isEditMode}
            errorsGenerality={
              formContext.errors.generality as FormikErrors<AccordionGeneralityForm>
            }
            errorsPerson={formContext.errors.person as FormikErrors<AccordionPersonForm>}
            touchedPerson={formContext.touched.person as FormikTouched<AccordionPersonForm>}
            touchedGenerality={
              formContext.touched.generality as FormikTouched<AccordionGeneralityForm>
            }
            onChangeValues={onChangeValues}
            resetForm={resetForm}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionGeneralityComponent.displayName = 'Accordion generality component';

const AccordionGenerality = memo(AccordionGeneralityComponent);

export default AccordionGenerality;
